
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Hızlı Tedarik',
      description: 'Geniş ürün yelpazesi ve güçlü tedarik ağımızla endüstriyel ihtiyaçlarınızı hızla karşılıyoruz.',
      features: [
        'Hızlı teslimat garantisi',
        'Geniş stok kapasitesi',
        'Kaliteli ürün garantisi',
        '7/24 sipariş desteği'
      ],
      image: 'https://readdy.ai/api/search-image?query=Industrial%20supply%20warehouse%20with%20organized%20steel%20fasteners%20and%20bolts%2C%20professional%20logistics%20and%20inventory%20management%2C%20modern%20storage%20facility%20with%20systematic%20arrangement%20of%20industrial%20components%2C%20efficient%20supply%20chain%20operations%20with%20metallic%20surfaces&width=500&height=300&seq=supply&orientation=landscape'
    },
    {
      icon: 'ri-search-line',
      title: 'Ürün Bulma Hizmeti',
      description: 'Özel ihtiyaçlarınız için doğru ürünü bulup tedarik ediyoruz. Standart dışı ürünler için özel çözümler sunuyoruz.',
      features: [
        'Özel ürün arama hizmeti',
        'Alternatif ürün önerileri',
        'Teknik özellik karşılaştırması',
        'Maliyet optimizasyonu'
      ],
      image: 'https://readdy.ai/api/search-image?query=Product%20sourcing%20and%20selection%20service%20with%20technical%20specifications%2C%20professional%20product%20catalog%20and%20comparison%20charts%2C%20industrial%20fastener%20selection%20process%20with%20quality%20assessment%2C%20modern%20procurement%20solutions&width=500&height=300&seq=sourcing&orientation=landscape'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Teknik Danışmanlık',
      description: 'Uzman ekibimizle projelerinizde doğru bağlantı elemanı seçimi konusunda profesyonel destek sağlıyoruz.',
      features: [
        'Teknik ürün danışmanlığı',
        'Malzeme seçim desteği',
        'Uygulama alanı analizi',
        'Proje optimizasyonu'
      ],
      image: 'https://readdy.ai/api/search-image?query=Technical%20consultation%20service%20with%20professional%20engineers%20reviewing%20product%20specifications%2C%20modern%20office%20environment%20with%20technical%20catalogs%20and%20steel%20samples%2C%20expert%20consultation%20for%20industrial%20projects%20with%20precision%20tools&width=500&height=300&seq=consulting&orientation=landscape'
    }
  ];

  const processSteps = [
    {
      step: '01',
      title: 'İhtiyaç Analizi',
      description: 'Projenizin gereksinimlerini detaylı olarak analiz ediyoruz.'
    },
    {
      step: '02',
      title: 'Ürün Araştırması',
      description: 'En uygun ürünleri araştırıp size en iyi seçenekleri sunuyoruz.'
    },
    {
      step: '03',
      title: 'Tedarik & Kalite',
      description: 'Güvenilir tedarikçilerden yüksek kaliteli ürünleri temin ediyoruz.'
    },
    {
      step: '04',
      title: 'Teslimat & Destek',
      description: 'Zamanında teslimat ve sürekli müşteri desteği sağlıyoruz.'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.7)), url('https://readdy.ai/api/search-image?query=Professional%20industrial%20supply%20services%20and%20product%20sourcing%2C%20modern%20warehouse%20facility%20with%20technical%20expertise%2C%20precision%20supply%20chain%20services%20with%20steel%20components%20and%20professional%20consultation%2C%20high-tech%20industrial%20environment%20with%20quality%20assurance&width=1920&height=600&seq=services-hero&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 text-center text-white">
            <h1 
              className="text-5xl md:text-6xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Hizmetlerimiz
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              İhtiyacınıza özel tedarik çözümleri sunuyoruz
            </p>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 
                className="text-4xl font-bold text-slate-800 mb-4"
                style={{ fontFamily: 'Exo 2, sans-serif' }}
              >
                Kapsamlı Hizmet Portföyümüz
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Endüstriyel projelerinizin her aşamasında yanınızdayız
              </p>
            </div>

            <div className="space-y-16">
              {services.map((service, index) => (
                <div 
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
                  }`}
                >
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                      <i className={`${service.icon} text-2xl text-orange-500`}></i>
                    </div>
                    <h3 
                      className="text-3xl font-bold text-slate-800 mb-4"
                      style={{ fontFamily: 'Exo 2, sans-serif' }}
                    >
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-3">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center space-x-3">
                          <i className="ri-check-line text-orange-500 text-lg"></i>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full rounded-lg shadow-lg object-cover object-top"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 
                className="text-4xl font-bold text-slate-800 mb-4"
                style={{ fontFamily: 'Exo 2, sans-serif' }}
              >
                Çalışma Sürecimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Profesyonel yaklaşımımızla projelerinizi başarıya ulaştırıyoruz
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {processSteps.map((step, index) => (
                <div key={index} className="text-center">
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span 
                        className="text-2xl font-bold text-white"
                        style={{ fontFamily: 'Exo 2, sans-serif' }}
                      >
                        {step.step}
                      </span>
                    </div>
                    {index < processSteps.length - 1 && (
                      <div className="hidden lg:block absolute top-10 left-1/2 w-full h-0.5 bg-orange-200 transform translate-x-1/2"></div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Quality Assurance */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Quality%20control%20and%20inspection%20of%20industrial%20fasteners%20in%20modern%20facility%2C%20precision%20measurement%20equipment%20and%20quality%20assurance%20processes%2C%20professional%20testing%20of%20steel%20bolts%20and%20nuts%2C%20high-tech%20quality%20control%20with%20measurement%20tools%20and%20certification&width=600&height=400&seq=quality&orientation=landscape"
                  alt="Kalite Güvencesi"
                  className="w-full rounded-lg shadow-lg object-cover object-top"
                />
              </div>
              <div>
                <h2 
                  className="text-4xl font-bold text-slate-800 mb-6"
                  style={{ fontFamily: 'Exo 2, sans-serif' }}
                >
                  Kalite Güvencemiz
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Tedarik ettiğimiz her ürünün kalitesini titizlikle kontrol ediyoruz. 
                  Sadece sertifikalı ve güvenilir üreticilerden temin ettiğimiz ürünlerle çalışıyoruz.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <i className="ri-award-line text-orange-500 text-xl"></i>
                    <span className="text-gray-700">Sertifikalı Tedarikçi Ağı</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-shield-check-line text-orange-500 text-xl"></i>
                    <span className="text-gray-700">Kalite Kontrol Süreci</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-test-tube-line text-orange-500 text-xl"></i>
                    <span className="text-gray-700">Malzeme Test Sertifikaları</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-double-line text-orange-500 text-xl"></i>
                    <span className="text-gray-700">100% Müşteri Memnuniyeti</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-slate-800 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 
              className="text-4xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Projeniz İçin Doğru Ürünü Bulalım
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Uzman ekibimizle ihtiyaçlarınızı değerlendirip, size en uygun ürünleri tedarik edelim
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/iletisim">
                <Button size="lg" className="w-full sm:w-auto">
                  Ücretsiz Danışmanlık Al
                </Button>
              </Link>
              <Link to="/urunler">
                <Button variant="outline" size="lg" className="w-full sm:w-auto">
                  Ürünleri İncele
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
